import { render, staticRenderFns } from "./CatalogHistoryModal.vue?vue&type=template&id=a9a2bece&"
import script from "./CatalogHistoryModal.vue?vue&type=script&lang=js&"
export * from "./CatalogHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports